module.exports = __webpack_public_path__ + "static/money-35ff2977a03d8854740a67328b2b88d7.svg";